import { render, staticRenderFns } from "./index.vue?vue&type=template&id=504e4b9e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=504e4b9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e4b9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504e4b9e')) {
      api.createRecord('504e4b9e', component.options)
    } else {
      api.reload('504e4b9e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=504e4b9e&scoped=true&", function () {
      api.rerender('504e4b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/noticeboard/index.vue"
export default component.exports